import { useTranslation } from "react-i18next";
import {Chip, Tooltip} from "@mui/material";
import i18n from "i18next";
import {Consts} from "../pages/consts";
import {capitalizeFirstLetter} from "../pages/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

const PatientGeneRow = ({
                          number,
                          gene,
                          handleDrugClick,
                          handleGeneDetails,
                          init,
                          printView = false,
                          onDeleteGene,
                          deleteVisible}) => {
  const { t: t } = useTranslation();

  const renderRisks = (risks, label) => (
    <>
      {risks.length > 0 && (
        <div>
          <label className="bold-label">{t(label)}{ label === "" ? "" : ":" }</label>
          {risks?.map((risk, i) => {
            let substance = JSON.parse(risk?.recommendation)[i18n.language?.toUpperCase()]?.substanceName;

            if(substance === ""){
              substance = risk.substanceKey;
            }

            return (
              <label
                key={`risk${number}_${i}`}
                className={printView ? "w3-margin-left" : "label-link w3-margin-left"}
                onClick={() => handleDrugClick(risk, gene)}
              >
                {i18n.language === "de" ? capitalizeFirstLetter(substance) : substance}
              </label>
            )})
          }
        </div>
      )}
    </>
  );

  return (
    <div className="w3-row  w3-margin-bottom w3-border w3-border-grey w3-round-large">
      <div className="w3-col s2 w3-mobile">
        <Tooltip
          title={`${gene?.testDate}: ${gene?.labName}`}
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: '1.3rem',
              },
            },
          }}
        >
          <Chip
            value={gene}
            label={<label className={ init ? "chip-label_link" : "chip-label" }>{gene?.geneName}</label>}
            sx={{ backgroundColor: "#1b7a9f", color: "#fff", margin: "5px" }}
            onClick={() => handleGeneDetails(gene)}
          />
        </Tooltip>
        {printView &&
          <label>{`${t("date")}: ${gene?.testDate}, ${t("laboratory_name")}: ${gene?.labName}`}</label>}
      </div>
      <div className="w3-col s2 w3-mobile">
        <label>{gene?.genotype || t(Consts.NOT_SPECIFIED)}</label>
      </div>
      <div className="w3-col s3 w3-mobile">
        <label>{gene?.phenotype ? t(gene.phenotype) : t(Consts.NOT_SPECIFIED)}</label>
      </div>
      <div className="w3-col s4 w3-mobile">
        {renderRisks(gene?.phenoRisks || [], "phenotype_related")}
        {renderRisks(gene?.genoRisks || [], "genotype_related")}
        {renderRisks(gene?.risks || [], "")}
        {!gene?.risks?.length && !gene?.phenoRisks?.length && !gene?.genoRisks?.length &&
          <div className="w3-margin-left"><label>{t("not_found")}</label></div>
        }
      </div>
      { deleteVisible && <div className="w3-col s1 w3-mobile">
        <button
          type="button"
          onClick={ () => onDeleteGene(gene) }
          className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left w3-right w3-padding-small"
        >
          <FontAwesomeIcon icon={ faTrash }/>
        </button>
      </div> }
    </div>
  );
};

export default PatientGeneRow;
